import { render, staticRenderFns } from "./NewsletterForm.vue?vue&type=template&id=0d5dee3f"
import script from "./NewsletterForm.vue?vue&type=script&lang=js"
export * from "./NewsletterForm.vue?vue&type=script&lang=js"
import style0 from "./NewsletterForm.vue?vue&type=style&index=0&id=0d5dee3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports